export const kindBusinessExceptions = [];
